<div kalDialogContent>
    <div class="container">
        <app-viewer-document *ngIf="viewerDocumentsList?.length === 1; else multiplePrints"
                             [removeCourrierId]="viewerDocumentsList[0].removeCourrierId"
                             [report]="viewerDocumentsList[0].report"
                             [filename]="viewerDocumentsList[0].fileName"
                             (closeViewer)="close()">
        </app-viewer-document>
    </div>

</div>

<ng-template #multiplePrints>
    <app-viewers-container
        (closeContainer)="close()"
        [viewerDocumentsList]="data.viewerDocumentsList">
    </app-viewers-container>
</ng-template>
